import axios from 'axios';
import Cookies from 'js-cookie';
// config
import { HOST_API_KEY, API_KEY } from '../config-global';

// routes
import { PATH_AUTH } from '../routes/paths';

// import { setSession,  setAuthCookies } from '../auth/utils';



// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API_KEY });

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {

    // try {
    const originalRequest = error.config;

    // console.log(error)


    if (error.response && error.response.status) {
      console.log('error.response.status: ', error.response.status)
      console.log('error.code: ', error.code)
      // if (error.response.status === 403 && !originalRequest._retry) {
      // if (error.response.status === 401 && !originalRequest._retry) {
      //   originalRequest._retry = true;
      //   await refreshTokenFn();
      //   // const access_token = await refreshTokenFn();
      //   // axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
      //   return axiosInstance(originalRequest);
      // }

      // switch (error.response.status) {
      //   case '429':
      //      return Promise.reject((error.response && error.response.data) || 'Something went wrong')
      //     break;
      //   case '500':
      //     return Promise.reject((error.response && error.response.data) || 'Something went wrong')
      //     break;

      //   default:
      //     break;
      // }
      if (error.response.status === 429) {

        // console.log('Limit exceeded')
        alert("API CALL LIMIT EXCEEDED")
        globalLogout();

        // if (originalRequest.url !== "/logout")
        window.location.href = "/user/login";

      }
      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        const isRefreshed = await refreshTokenFn();
        if (isRefreshed) {
          originalRequest.headers.Authorization = axiosInstance.defaults.headers.common.Authorization;
          return axiosInstance(originalRequest);
        }
      }
      if (error.response.status === 403 && error.response.data) {
        // return Promise.reject(error.response.data);
        console.log('error 403')
      }
    }
    if (error.code && error.code === "ERR_NETWORK" && !originalRequest._retry) {
      console.log("ERR NETWORK");
    }

    return Promise.reject((error.response && error.response.data) || 'Something went wrong')
    // } catch (err) {
    //   return Promise.reject((error.response && error.response.data) || 'Something went wrong')
    // }
    // // window.location.href = "/app/logout";
    // return Promise.reject((error.response && error.response.data) || 'Something went wrong')





  }
);

export const clearCookies = () => {
  Cookies.remove("jwt.id");
  Cookies.remove("jwt.refresh");
  Cookies.remove("jwt.access");
  Cookies.remove("jwt.expires");
  Cookies.remove("userProfileURL");
}

export const globalLogout = () => {
  clearCookies();
  setSession(null);
}

const refreshTokenFn = async () => {

  const refreshTokenCookies = Cookies.get('jwt.refresh')
    // console.log("refreshTokenCookies: ");
    // console.log(refreshTokenCookies);
    ;
  if (!refreshTokenCookies) {
    globalLogout();
    return false;
  }

  try {
    const response = await axiosInstance.post('/refresh-token', { refreshToken: refreshTokenCookies });

    const { expiresIn, refreshToken, accessToken, idToken } = response.data;

    // console.log(response.data)

    if (!(refreshToken && accessToken && idToken)) {
      throw new Error("token is expired")
    }


    setSession(idToken);
    setAuthCookies({
      idToken,
      accessToken,
      refreshToken,
      expiresIn,
    });
    return true;
  } catch (error) {
    globalLogout();
    return false;
  }

}


const setSession = (idToken: string | null) => {
  // console.log('setSession')
  if (idToken) {
    // console.log(`idToken`)
    // console.log(idToken)
    axiosInstance.defaults.headers.common.Authorization = `Bearer ${idToken}`;
  } else {
    delete axiosInstance.defaults.headers.common.Authorization;
  }
};

interface cookiesData {
  idToken: string,
  refreshToken: string,
  accessToken: string,
  // username: string,
  // userId: string,
  expiresIn: number,
}

const setAuthCookies = (data: cookiesData) => {

  // console.log(data)

  const idToken = data.idToken;
  const refreshToken = data.refreshToken;
  const accessToken = data.accessToken;
  // const username = data.username;
  Cookies.set('jwt.id', idToken);

  if (refreshToken)
    Cookies.set('jwt.refresh', refreshToken);

  Cookies.set('jwt.access', accessToken);
  const expiresIn = data.expiresIn;
  const exp = new Date();
  const totalSeconds = exp.getSeconds() + expiresIn;
  exp.setSeconds(totalSeconds);
  Cookies.set('jwt.expires', exp.toISOString());
}









const apiKey = process.env.REACT_APP_API_KEY;

if (apiKey)
  axiosInstance.defaults.headers["x-api-key"] = apiKey;



export default axiosInstance;

